export const FLAG_TYPE_VALUES = ["boolean", "counter"];
export const FlagType = {
    BOOLEAN: "boolean",
    COUNTER: "counter",
};
export const FLAG_EFFECT_OP_VALUES = ["set", "add"];
export const FlagEffectOp = {
    SET: "set",
    ADD: "add",
};
export const FLAG_CONDITION_CMP_VALUES = ["eq", "gte", "lte"];
export const FlagConditionCmp = {
    EQ: "eq",
    GTE: "gte",
    LTE: "lte",
};
